import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { WEB_COMPONENT_GRID_VIEW } from '../../../webcomponents.constants';
import { GridViewWebComponent } from '../../../grid/gridView';
import { Column, ColumnKeys, TagItem } from '../types';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { GridConfig } from './GridConfig';
import { TagsManagerGridDataProvider } from '../dataProvider/TagsManagerGridDataProvider';
import { OnTagNameClick } from '../events/events';
import { Dependencies } from '../../types/dependencies';

export class TagsManagerGridView extends BaseWebComponentView {
  public dom: {
    $grid: GridViewWebComponent<Column, ColumnKeys, TagItem>;
    $addTagButton: GzButtonWebComponent;
    $deleteTagsButton: GzButtonWebComponent;
    $hostElement: HTMLElement;
    $title: HTMLElement;
  };

  public dependencies: Dependencies;

  getDomElements() {
    this.dom = {
      $grid: this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW),
      $addTagButton: this.shadow.querySelector('[data-add-tag]'),
      $deleteTagsButton: this.shadow.querySelector('[data-delete-tags]'),
      $hostElement: this.shadow,
      $title: this.shadow.getElementById('page-title'),
    };
  }

  public buildView(): void {
    const dispatcher = {
      tagNameClickEvent: this.dispatchTagNameClickedEvent.bind(this),
    };
    const { defaultViewProperties } = new GridConfig(dispatcher).getDataForView(this.dependencies);

    this.buildGrid(defaultViewProperties);
    this.setTranslations();
  }

  private buildGrid(defaultViewProperties): void {
    const grid = this.dom.$grid;

    grid.propertiesSet = false;
    grid.dataProvider = new TagsManagerGridDataProvider(this.dependencies);
    grid.sideMenuParent = this.dom.$hostElement;

    for (const [key, value] of Object.entries(defaultViewProperties)) {
      grid[key] = value;
    }

    grid.propertiesSet = true;
    grid.injectDependencies(this.dependencies);
    grid.start().catch();
  }

  private setTranslations(): void {
    this.dom.$addTagButton.innerText = this.dependencies.translateFn('Create tag');
    this.dom.$deleteTagsButton.innerText = this.dependencies.translateFn('Delete');
    this.dom.$title.textContent = this.dependencies.translateFn('Tags management');
  }

  dispatchTagNameClickedEvent(tagId: string, tagName: string) {
    this.dom.$grid.dispatchEvent(new OnTagNameClick(tagId, tagName));
  }
}
